
import { useState, useCallback } from 'react';

export const useSettingsState = (initialState: {
  theme: string;
  tokenIcon: string;
  backgroundImage: string | null;
  backgroundImageSizing: 'cover' | 'repeat';
}) => {
  const [theme, setTheme] = useState(initialState.theme);
  const [tokenIcon, setTokenIcon] = useState(initialState.tokenIcon);
  const [backgroundImage, setBackgroundImage] = useState<string | null>(initialState.backgroundImage);
  const [backgroundImageSizing, setBackgroundImageSizing] = useState<'cover' | 'repeat'>(initialState.backgroundImageSizing);

  const handleSetTheme = useCallback((newTheme: string) => {
    setTheme(newTheme);
  }, []);

  const handleSetTokenIcon = useCallback((icon: string) => {
    setTokenIcon(icon);
  }, []);
  
  const handleSetBackgroundImageSizing = useCallback((sizing: 'cover' | 'repeat') => {
    setBackgroundImageSizing(sizing);
  }, []);

  return {
    theme,
    tokenIcon,
    backgroundImage,
    backgroundImageSizing,
    setTheme,
    setTokenIcon,
    setBackgroundImage,
    setBackgroundImageSizing,
    handleSetTheme,
    handleSetTokenIcon,
    handleSetBackgroundImageSizing,
  };
};
